import { useEffect, useState } from 'react';

export default function useHiddenBreadcrumbs(containerRef) {
  const [breadcrumbsWidth, setBreadcrumbsWidth] = useState(0);
  const [windowWidth, setWindowWidth] = useState(0);
  const [showHiddenBreadcrumbs, setShowHiddenBreadcrumbs] = useState(false);
  const [breadcrumbsOverflows, setBreadcrumbsOverflows] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setBreadcrumbsWidth(containerRef.current?.children[0].scrollWidth);
  }, [containerRef.current]);

  useEffect(() => {
    setShowHiddenBreadcrumbs(false);
    if (breadcrumbsWidth >= windowWidth - 28) {
      setBreadcrumbsOverflows(true);
    } else {
      setBreadcrumbsOverflows(false);
      setBreadcrumbsWidth(containerRef.current?.children[0].scrollWidth);
    }
  }, [windowWidth]);

  return {
    showHiddenBreadcrumbs,
    setShowHiddenBreadcrumbs,
    breadcrumbsOverflows,
  };
}
